// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2DLF8Hu1kRRM6RyKAyJQCa","receipt-total-box":"_2aoksUSD39Q7XWXSJOs16G","receipt-cash-box":"aSzQAy8d0b0vrrrHybIvM","receipt-change-box":"_2sDpdlUxipssn2W-pKSefw"};